'use strict';

import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";

//Formda delay(ms) ve state (fulfilled | rejected) alın.
//Submit’te preventDefault; belirtilen gecikme sonrası seçilen duruma göre resolve/reject edin.
//Sonucu iziToast ile gösterin:
//✅ Fulfilled: Fulfilled promise in ${delay}ms
//❌ Rejected: Rejected promise in ${delay}ms

//Radyo düğmelerinde bir durum seçildiğinde ve Create notification düğmesine basıldığında, seçilen stile uygun olarak belirtilen süre gecikmeli bir şekilde gösterilmelidir, bu süre input'a aktarılmış olmalıdır.
//Ekrana yazdırılan bildirim, koşullardaki şablona göre seçilen durumun türünü ve milisaniye cinsinden süreyi içermelidir.

const button = document.querySelector('button[type="submit"]');

button.addEventListener('click', (event) => {
    event.preventDefault();

    const delay = document.querySelector('[name="delay"]');
    const state = document.querySelector('[name="state"]:checked');

    if (!state) {
        iziToast.caution({
                position: 'topCenter',
                message: 'Please select a state',
              });
        return;
    }

    const promise = new Promise((resolve, reject) => {
        setTimeout(() => {
            if (state.value === 'fulfilled') {
                resolve(`Fulfilled promise in ${delay.value}ms`);
            } else {
                reject(`Rejected promise in ${delay.value}ms`);
            }
        }, delay.value);
    });

      promise
          .then(value => {
              iziToast.success({
                position: 'topCenter',
                message: value,
              });
              console.log(value)
          })
          .catch(error => {
            iziToast.error({
                position: 'topCenter',
                message: error,
              });
              console.log(error)
          })
});

